import { render, staticRenderFns } from "./prohibition.vue?vue&type=template&id=e5d94294"
import script from "./prohibition.vue?vue&type=script&lang=js"
export * from "./prohibition.vue?vue&type=script&lang=js"
import style0 from "./prohibition.vue?vue&type=style&index=0&id=e5d94294&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports